import { normalizeFloatingNumberCorrection } from "utils/common";
import {
  CartInfo,
  CartItem,
  StepData,
  StepId,
} from "../hearing-aids-wizard.type";
import {
  getHearingAidItem,
  getReceiverItem,
  getEarmoldItem,
  getDomeItem,
  getTubeItem,
  getAccessoriesItems,
  getManufacturerWarrantyItem,
  getLndWarrantyItem,
  getDiscountPercent,
} from "./get-cart-item.util";
import { sum } from "lodash";
import { CONFIGURATION_STEP } from "../../constants";

const hasIncorrectDiscounts = (items: CartItem[]) =>
  items.some(
    (item) =>
      item.product.discount_percent &&
      item.product.discount_percent > Number(item.product.product.max_discount)
  );

export const getCartInfo = (stepsData: Record<StepId, StepData>) => {
  const earsConfig = stepsData[CONFIGURATION_STEP]?.ears;

  const hearingAids = [
    getHearingAidItem(stepsData, "left"),
    getHearingAidItem(stepsData, "right"),
  ].filter(Boolean) as CartItem[];

  const receivers = [
    getReceiverItem(stepsData, "left"),
    getReceiverItem(stepsData, "right"),
  ].filter(Boolean) as CartItem[];

  const earmolds = [
    getEarmoldItem(stepsData, "left"),
    getEarmoldItem(stepsData, "right"),
  ].filter(Boolean) as CartItem[];

  const domes = [
    getDomeItem(stepsData, "left"),
    getDomeItem(stepsData, "right"),
  ].filter(Boolean) as CartItem[];

  const tubes = [
    getTubeItem(stepsData, "left"),
    getTubeItem(stepsData, "right"),
  ].filter(Boolean) as CartItem[];

  const warranties = [
    getManufacturerWarrantyItem(stepsData),
    getLndWarrantyItem(stepsData),
  ].filter(Boolean) as CartItem[];

  const accessories = getAccessoriesItems(stepsData);

  const parentProducts = [...hearingAids, ...earmolds, ...accessories];

  const childProducts = [...receivers, ...domes, ...tubes];

  let count = sum([
    ...parentProducts.map((product) => product.product.quantity),
    ...childProducts.map((product) => product.product.quantity),
    ...warranties.map((product) => product.product.quantity),
  ]);

  const actual_prices = [
    ...parentProducts.map(({ product }) => product.actual_price),
    ...warranties.map(({ product }) => product.actual_price),
  ];

  const actual_price_sum = normalizeFloatingNumberCorrection(
    sum(actual_prices)
  );

  const original_prices = [
    ...parentProducts.map(({ product }) =>
      product.original_price_with_components
        ? product.original_price_with_components
        : product.original_price * product.quantity
    ),
    ...warranties.map(({ product }) => product.original_price),
  ];

  const original_price_sum = normalizeFloatingNumberCorrection(
    sum(original_prices)
  );

  const result: CartInfo = {
    hasIncorrectDiscounts: hasIncorrectDiscounts(parentProducts),
    earsConfig,
    hearingAids,
    receivers,
    tubes,
    domes,
    earmolds,
    accessories,
    warranties,
    count,
    actual_price_sum,
    original_price_sum,
    discount_percent: getDiscountPercent(actual_price_sum, original_price_sum),
    discount_sum:
      original_price_sum > actual_price_sum
        ? normalizeFloatingNumberCorrection(
            original_price_sum - actual_price_sum
          )
        : 0,
  };

  return result;
};
